var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPyram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pyram 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.011 71.163C270.543 106.721 290.621 141.492 310.928 176.66C270.246 176.66 229.929 176.66 189.104 176.66C209.319 141.645 229.429 106.812 250.011 71.163Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.746 333.155C119.189 368.568 139.212 403.254 159.494 438.388C118.836 438.388 78.791 438.388 38.001 438.388C58.276 403.264 78.327 368.527 98.746 333.155Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M401.275 333.155C421.683 368.504 441.705 403.191 462 438.345C421.375 438.345 381.332 438.345 340.561 438.345C360.777 403.318 380.828 368.58 401.275 333.155Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.235 438.43C209.609 403.143 229.623 368.477 249.968 333.242C270.351 368.544 290.4 403.268 310.7 438.43C270.016 438.43 229.987 438.43 189.235 438.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.222 193.807C229.984 193.807 269.969 193.807 310.703 193.807C290.42 228.944 270.367 263.682 249.97 299.02C229.623 263.778 209.598 229.098 189.222 193.807Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.949 307.287C285.205 272.208 305.197 237.586 325.648 202.168C346.107 237.605 366.097 272.229 386.336 307.287C345.652 307.287 305.631 307.287 264.949 307.287Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M325.604 430.023C305.165 394.625 285.202 360.044 264.973 325.009C305.588 325.009 345.608 325.009 386.225 325.009C366.035 359.98 346.07 394.566 325.604 430.023Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.007 307.329C194.33 307.329 154.367 307.329 113.663 307.329C133.899 272.278 153.892 237.648 174.334 202.241C194.761 237.621 214.755 272.251 235.007 307.329Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.753 324.944C154.418 324.944 194.363 324.944 234.995 324.944C214.785 359.953 194.833 394.517 174.385 429.939C154.035 394.697 134.05 360.09 113.753 324.944Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPyram);
export default __webpack_public_path__ + "static/media/pyram.d45ba68e023843f5ac808eb90797ca7b.svg";
export { ForwardRef as ReactComponent };